import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useMediaQuery, useTheme } from "@mui/material";
import makeStyles from "@material-ui/core/styles/makeStyles";
import IconButton from "@mui/material/IconButton";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import AddIcon from '@mui/icons-material/Add';



const useStyles = makeStyles((theme: any) => ({
  dialogRoot: {
    position: "relative",
  },
  dialogTitleRoot: {
    "& .MuiTypography-h6": {
      fontSize: 16,
      color: theme.palette.common.dark,
    },
  },
  dialogActionsRoot: {
    padding: "16px 24px",
  },
}));

export interface IPostDialog {
  onClose?: any;
  dialogContent?: any;
  actionFunc?: any;
  open: boolean;
  title?: any;
  // headerContent?: any;
  editLoading: boolean;
  // maxWidth: string;
}

const BootstrapDialogTitle = (props: any) => {
  //Props
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2, backgroundColor: "#fff" }} {...other}>
      {children}
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme: any) => theme.palette.grey[500],
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </DialogTitle>
  );
};

export default function PostEditDialog(props: IPostDialog) {
  //Props
  const {
    onClose,
    open,
    // headerContent,
    dialogContent,
    actionFunc,
    title,
    editLoading
  } = props;

  //redux

  //Hooks
  const theme = useTheme();
  const reduceWidth = useMediaQuery(theme.breakpoints.down("md"));
  const classes = useStyles();

  const handleCancel = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      maxWidth="xl"
      fullWidth={true}
      style={{
        userSelect: "none", // empêcher la selection du texte sur l'interface utilisateur de l'application
      }}
    >
      <Box component="form">
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleCancel}
        >
          <Typography variant="h6">{title}</Typography>
        </BootstrapDialogTitle>
        <DialogContent
          dividers
          style={{
            // padding: reduceWidth ? "10px 10px" : "30px 45px",
            height: "60vh",
            background: "#f4f4f7",
          }}
        >
          {dialogContent}
        </DialogContent>
        <DialogActions style={{ margin: 10 }}>
          <LoadingButton
            loadingPosition="end"
            loading={editLoading}
            size="small"
            variant="contained"
            onClick={actionFunc}
            type="submit"
          >
            Modifier
          </LoadingButton>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
